import React, { ReactNode, MouseEvent, FC } from 'react';

import { CSSProp } from 'styled-components';

import { RenderIconType } from '@adsk/alloy-react-icon';
import { MenuItem } from '@adsk/alloy-react-menu';
import theme from '@adsk/alloy-react-theme';

import UnstyledAnchor from './UnstyledAnchor';

type EntityMenuItemProps = {
  className?: string;
  style?: CSSProp;
  link?: string;
  onClick?: (e: MouseEvent) => void;
  renderIcon?: RenderIconType;
  label: ReactNode | string;
};

const EntityMenuItem: FC<EntityMenuItemProps> = ({
  className,
  style,
  label,
  link,
  renderIcon,
  onClick,
}) => (
  <MenuItem
    as={link ? UnstyledAnchor : 'button'}
    label={label}
    onClick={(e) => {
      e.stopPropagation(); // DO NOT REMOVE - Fix for LinkedReferencesCell within MatrixTable [WPX-967]
      onClick?.(e);
    }}
    href={link}
    target="_blank"
    className={className}
    style={[{ svg: { color: theme.colors.charcoal600 } }, style]}
    renderIcon={renderIcon}
    showSelection={false}
  />
);

export default EntityMenuItem;
